import { render, staticRenderFns } from "./PriceFrame.vue?vue&type=template&id=e07248dc&scoped=true&"
import script from "./PriceFrame.vue?vue&type=script&lang=js&"
export * from "./PriceFrame.vue?vue&type=script&lang=js&"
import style0 from "./PriceFrame.vue?vue&type=style&index=0&id=e07248dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07248dc",
  null
  
)

export default component.exports